import React, { useEffect, useRef, useState } from "react";
import styles from "./scss/dropdown.module.scss"; // Adjust the path

const CustomDropdown = ({ label = "Select", options = [], onSelect, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSelect = (selectedValue) => {
    onSelect?.(selectedValue);
    setIsOpen(false);
  };

  const selectedOption = options?.find(opt => opt?.value === value) || { name: value || label };

  return (
    <div className={styles.dropdownmenu} ref={ref}>
      <div className={styles.dropdownmenuname} onClick={() => setIsOpen(!isOpen)}>
        {selectedOption?.name || label}
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none" style={{transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"}}>
          <path d="M0.72 0.06C0.85 0.06 0.98 0.11 1.08 0.21L3.65 2.79C3.74 2.88 3.87 2.93 4 2.94C4.13 2.94 4.26 2.88 4.35 2.79L6.92 0.21C7.12 0.02 7.43 0.02 7.63 0.21C7.83 0.41 7.83 0.72 7.63 0.92L5.06 3.49C4.78 3.78 4.4 3.94 4 3.94C3.6 3.93 3.22 3.78 2.94 3.49L0.37 0.92C0.17 0.72 0.17 0.41 0.37 0.21C0.47 0.11 0.6 0.06 0.72 0.06Z" fill="black" />
        </svg>
      </div>
      {isOpen && (
        <div className={`${styles.dropdownmenuoption} dropdownmenuoptioncustom`}>
          {options.map((option, index) => (
            <div
              key={index}
              className={styles.dropdownmenuoptioninner}
              onClick={() => handleSelect(option.value)}
            >
              {option.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default CustomDropdown;
